type PencilProps = {
  ClassNameImg?: string;
};

export const Pencil: React.FC<PencilProps> = ({ ClassNameImg }) => {
  return (
    <svg
      className={ClassNameImg}
      width='9'
      height='9'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.1386 0.375265C12.379 0.13498 12.705 0 13.0449 0C13.3848 0 13.7108 0.13498 13.9512 0.375265L15.6247 2.04882C15.865 2.28923 16 2.61522 16 2.95512C16 3.29503 15.865 3.62102 15.6247 3.86143L13.7421 5.74504L10.255 2.25789L12.1386 0.375265ZM4.32799 15.1592C4.2592 15.2276 4.17171 15.2743 4.07651 15.2933L0.589366 15.9905C0.509824 16.0063 0.427605 16.0023 0.349992 15.9788C0.27238 15.9552 0.201772 15.9129 0.144423 15.8556C0.0870751 15.7982 0.0447576 15.7276 0.0212209 15.65C-0.00231587 15.5724 -0.00634493 15.4902 0.00949002 15.4106L0.706722 11.9245C0.725794 11.8288 0.772813 11.7409 0.84183 11.672L9.55773 2.95512L13.0449 6.44227L4.32799 15.1592Z'
        fill='#0F1418'
      />
    </svg>
  );
};
